module.exports = __webpack_public_path__ + "static/media/cloud-upload.7ef49c61.svg";